module.exports = __webpack_public_path__ + "img/titleOne.79925c0b.png";